import { axios } from '@/utils/request'
import relUtil from '@/utils/relUtil'
const api = relUtil.loginUrl;
//获取验证码
export async  function queryCaptcha(params) {
  return axios({
    url:  api + `/captcha/`,
    method: 'GET'
  })
}

//登录
export async  function newLogin(params) {
  return axios( {
    url:api + `/login/`,
    method: 'POST',
    data:params
  });
}



// WEBPACK FOOTER //
// ./src/service/login/loginService.js